import React, { useContext, useEffect, useState } from "react";

import { Container, Grid, LinearProgress } from "@mui/material";
import { PageHeader } from "../../common";
import { FetchContext, NavContext, NavRoutes } from "../../contexts";
import { CompetenzeContext, CompetenzeProvider } from "./CompetenzeContext";
import { CompetenzeList } from "./components";

const PageContent = (props) => {
  const { user } = useContext(FetchContext);

  const { addBreadcrumbToken, setBread, navigateTo } = useContext(NavContext);

  const {
    state,
    setState,

    isLoadingCompetenze,
    getCompetenzeAsync,

    isDeletingCompetenza,
    deleteCompetenzaAsync,
  } = useContext(CompetenzeContext);

  const { deleteCompetenza } = state;

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(isLoadingCompetenze || isDeletingCompetenza);
  }, [isLoadingCompetenze, isDeletingCompetenza]);

  const loadMoreHandler = async (pageIndex, pageSize, searchText) => {
    await getCompetenzeAsync(pageIndex, pageSize, searchText);
  };

  const [searchText, setSearchText] = useState("");
  const searchClickHandler = async (searchText) => {
    setSearchText(searchText);
  };

  const competenzeListActionClickHandler = async (action, data) => {
    switch (action) {
      case "Add":
        window.open(NavRoutes.CompetenzaAdd, "_blank").focus();
        break;
      case "Delete":
        await deleteCompetenzaAsync(data.id);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (user) {
      addBreadcrumbToken("Competenze");
      getCompetenzeAsync(0, 25, searchText);
    }
  }, [user]);

  const [openDeleteCompetenzaDialog, setOpenDeleteCompetenzaDialog] =
    useState(false);

  return (
    <>
      <Container>
        {isLoading && <LinearProgress />}
        <Grid container>
          <Grid item xs={12}>
            <PageHeader
              disabled={isLoading}
              onSearchClick={searchClickHandler}
              search
              title="Competenze"
              subtitle="Gestisci le competenze"
            />
          </Grid>
          <Grid item xs={12}>
            <CompetenzeList
              searchText={searchText}
              itemsPerPage={25}
              onLoadMore={loadMoreHandler}
              disabled={isLoading}
              onActionClick={competenzeListActionClickHandler}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export const CompetenzePage = () => {
  return (
    <CompetenzeProvider>
      <PageContent />
    </CompetenzeProvider>
  );
};
